export const colunas_ordenacao = [
  {
    descricao: 'Descrição Análise',
    campo: 'descricao_analise',
  },
  {
    descricao: 'Estoque PA (UND)',
    campo: 'estoque_pa',
  },
  {
    descricao: 'Estoque PA (PESO)',
    campo: 'estoque_pa_peso',
  },
  {
    descricao: 'Estoque MP',
    campo: 'estoque_mp',
  },
  {
    descricao: 'Estoque Geral',
    campo: 'total_estoque_peso',
  },
  {
    descricao: 'Projeção de vendas (UND)',
    campo: 'projecao_venda_pa',
  },
  {
    descricao: 'Projeção de vendas (PESO)',
    campo: 'projecao_venda_pa_peso',
  }
];
